import React, { useState, useEffect } from "react";
import { renameTable } from "../../../../../../../../../api/database_gui.js";
import RenameItemPopup from "../RenameItemPopup.js";

const RenameTablePopup = ({
  visible,
  onClose,
  onSave,
  currentName,
  resourceId,
  systemUserId,
  dbName,
  databaseInfo,
}) => {
  const [newName, setNewName] = useState(currentName);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setNewName(currentName);
  }, [currentName]);

  const handleSave = (newName) => {
    onSave(newName);
  };

  const renameTableFunction = async (newName) => {
    const response = await renameTable(
      resourceId,
      systemUserId,
      dbName,
      currentName,
      newName
    );
    return response;
  };

  return (
    <RenameItemPopup
      visible={visible}
      onClose={onClose}
      onSave={handleSave}
      currentName={currentName}
      newName={newName}
      setNewName={setNewName}
      loading={loading}
      setLoading={setLoading}
      renameFunction={renameTableFunction}
      successMessage="Table renamed successfully!"
      errorMessage="Error while renaming table."
      itemType="Table"
      databaseInfo={databaseInfo}
    />
  );
};

export default RenameTablePopup;
